// tslint:disable
import * as $ from 'jquery';
import * as React from 'react';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { ValidatorComponent } from '../libs/validator.component';
import { Validator } from '../libs/Validators';

export interface TextAreaFieldPropInterface {
    className?: string;
    title?: string;
    placeholder?: string;
    property?: string;
    validators?: Validator[];
    field: Field;
    disabled?: boolean;
    height?: number;
}

export class TextAreaField extends BaseField<TextAreaFieldPropInterface> {
    public field: Field = this.props.field;
    public state: any = {
        error: null,
        disabled: this.field.disabled
    };

    public style: any = {
        overflow: 'hidden',
        overflowWrap: 'break-word',
        resize: 'none',
        height: this.props.height || 72,
    };

    componentDidMount() {
        this.field.registerField();

        if (this.props.validators) {
            this.props.validators.forEach((v: Validator) => this.field.addValidator(v));
        }

        if (this.field.placeholder) {
            this.setState({placeholder: this.field.placeholder})
        }

        this.field.onValueChanges$.subscribe((value: any) => {
            this.setViewValue(value);
            this.field.onValidate$.next();
        });

        if (this.field.value && this.field.registered) {
            this.setViewValue(this.field.value);
        }

        if (typeof this.props.disabled !== 'undefined') {
            this.field.disabled = this.props.disabled;
            this.setState({disabled: this.field.disabled});
        }

        this.field.onDisableChanges$.subscribe((value: boolean) => {
            this.setState({disabled: value});
            this.field.disabled = value;
        });

    }



    setViewValue(value: any) {
        $(`#${this.uid + '_input'}`).val(value);
    }

    render() {
        return (
            <div className={this.props.className} id={this.uid}>
                <div className="form-group">
                    <label htmlFor={this.uid + '_input'}>{this.props.title || this.field.title}</label>
                    <div className="input-group">
                        <textarea
                            id={this.uid + '_input'}
                            className="form-control textarea-autosize textarea-counter"
                            data-counter="500"
                            data-parsley-id="4029"
                            style={this.style}
                            disabled={this.state.disabled}
                            onChange={(event: any) => this.onValueChange(event)}/>
                            <div className="required-field-mark"><ValidatorComponent icon="fa fa-exclamation" field={this.field}/></div>
                        
                    </div>
                </div>
            </div>
        );
    }

    private onValueChange(event: any) {
        let value: any = event.target.value;

        this.field.setValue(value);
        this.field.onValidate$.next();
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/textarea.field.tsx